import { MedicalPaOrder } from "../../../data-model/medicalPaOrdersModel";
import { AuthOnFileRpaStatus } from "../../../enums/authOnFileAuthStatus";
import { checkStatus } from "./checkRpaError";

interface RpaStatusBannerConfig {
  show: boolean;
  text: string;
}

export const getRpaStatusBanner = (
  orderData: MedicalPaOrder,
): RpaStatusBannerConfig => {
  const status = checkStatus(orderData);

  if (
    status === AuthOnFileRpaStatus.IN_PROGRESS ||
    status === AuthOnFileRpaStatus.INITIATED
  ) {
    return {
      show: true,
      text: "In Progress",
    };
  }

  return {
    show: false,
    text: "",
  };
};

interface RpaErrorBannerConfig {
  show: boolean;
  text: string;
  errorType?: string;
}

export const getRpaErrorBanner = (
  orderData: MedicalPaOrder,
): RpaErrorBannerConfig => {
  const status = checkStatus(orderData);

  if (status === AuthOnFileRpaStatus.ERROR) {
    return {
      show: true,
      text: "RPA Failed",
      errorType: orderData.status?.auth_on_file?.error_type,
    };
  }

  return {
    show: false,
    text: "",
  };
};
